module.exports = __webpack_public_path__ + "media/Header Video.f2cd360f.mp4";